import { ALL, SINGLE_SELECT } from './constants';

export const getFiltersDefaultState = ({ filters }) => {
  const defaultState = {};
  filters.forEach((filter) => {
    // No Option should be selected by default
    const defaultValue = filter.defaultSelection.code;
    defaultState[filter.key] = [];
    if (defaultValue === ALL) {
      const values = [];
      filter.values.forEach((value) => values.push(value.code));
      defaultState[filter.key] = values;
    } else {
      defaultState[filter.key] = defaultValue ? [defaultValue] : [];
    }
  });

  return defaultState;
};

export const getAllOptionsByFiltersName = ({ key, filters }) => {
  const filter = filters.find((filter) => filter.key === key);
  const options = filter.values.map((value) => value.code);
  return options;
};

export const getFiltersApplied = ({ superSetObj, filters }) => {
  const arrays = Object.values(superSetObj) as any[];
  const filtersApplied = arrays.reduce((total, array, index) => {
    const hasDefaultFilter = array.find(
      (code) => code === filters[index]?.defaultSelection?.code
    );
    return hasDefaultFilter ? total + array.length - 1 : total + array.length;
  }, 0);

  return filtersApplied;
};

export const getFiltersPayload = ({ superSetObj, sorters }) => {
  const payload = {
    filters: [],
    sorters: []
  };

  Object.entries(superSetObj).forEach(([key, value]: [string, string[]]) => {
    if (sorters?.find(({ key: sortKey }) => sortKey === key)) {
      if (value[0]) {
        if (!payload.sorters) payload.sorters = [];
        payload?.sorters?.push(value[0]);
      }
    } else {
      let values = [];
      for (let i = 0; i < value.length; i += 1) {
        if (value[i] === ALL) {
          values = [];
          break;
        }
        values.push(value[i]);
      }
      payload.filters.push({
        key,
        value: values
      });
    }
  });

  return payload;
};

export const getNewFilterState = ({
  filterType,
  value,
  filterObj,
  filterName,
  filters
}) => {
  let newState = null;
  if (filterType === SINGLE_SELECT) {
    newState = [value];
  } else {
    let currentState = [...filterObj[filterName]];
    const index = currentState.indexOf(value);
    if (index > -1) {
      // Already exist Deselect
      if (value === ALL) {
        // ALL deselect
        currentState = [];
      } else {
        currentState.splice(index, 1);
        const allIndex = currentState.indexOf(ALL);
        if (allIndex > -1) {
          currentState.splice(allIndex, 1);
        }
      }
    } else {
      // Select
      const allOptions = getAllOptionsByFiltersName({
        key: filterName,
        filters
      });
      if (value === ALL) {
        currentState = allOptions;
      } else {
        currentState.push(value);
        if (currentState.length + 1 === allOptions.length) {
          if (
            allOptions.find((option: string) => {
              return option === ALL;
            })
          )
            currentState.push(ALL);
        }
      }
    }
    newState = currentState;
  }
  return newState;
};

export const getFilterObjectFromRoute = ({
  defaultState,
  newFilterObj,
  filters
}) => {
  const modifiedFilterObj = newFilterObj;
  Object.entries(defaultState).forEach(([key, value]) => {
    if (modifiedFilterObj[key] !== defaultState[key]) {
      if (modifiedFilterObj[key] !== undefined) {
        const valueArray = String(modifiedFilterObj[key]).split(',');

        const filter = filters.find((filter) => filter.key === key);
        valueArray.forEach((queryValue, index) => {
          if (!filter.values.find((value) => value.code === queryValue)) {
            valueArray.splice(index, 1);
          }
        });

        modifiedFilterObj[key] = valueArray;
      } else modifiedFilterObj[key] = [];
    }
  });

  Object.entries(modifiedFilterObj).forEach(([key]) => {
    if (defaultState[key] === undefined) {
      delete modifiedFilterObj[key];
    }
  });

  return modifiedFilterObj;
};

export const onFilterApply = ({ filterObj }) => {
  const filterTypes = [];
  const filterValues = [];

  Object.entries(filterObj).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      filterTypes.push(key);
      filterValues.push(value.join(','));
    }
  });

  return { filterTypes, filterValues };
};

export const clearFilter = ({ filterObj, filter }) => {
  const clearState = { ...filterObj, [filter.key]: [] };
  const defaultValue = filter.defaultSelection.code;
  clearState[filter.key] = [];
  if (defaultValue === ALL) {
    const values = [];
    filter.values.forEach((value) => values.push(value.code));
    clearState[filter.key] = values;
  } else {
    clearState[filter.key] = defaultValue ? [defaultValue] : [];
  }

  return clearState;
};

export const routerReplace = ({ router, queryParams }) => {
  router.replace(
    {
      pathname: router.pathname,
      query: queryParams
    },
    undefined,
    { scroll: false }
  );
};
